import React from "react";

interface RatingsAndReviewsProps {
    title?: string;
    ratings: string[];
}

export const RatingsAndReviews: React.FC<RatingsAndReviewsProps> = ({ title = "Ratings and Reviews", ratings }) => {
    return (
        <div>
            <p className="text-lg font-medium pt-6">{title}</p>
            {ratings.map((rating, idx) => (
                <ul key={idx}>
                    <li key={idx}>{rating}</li>
                </ul>
            ))}
        </div>
    );
};

export default RatingsAndReviews;
